(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.swipeStart = null;
      this.swipeIsHorizontal = false;
      this.swipeFreezeUntil = 0;
      this.onTouchStartHandler = this.onTouchStart.bind(this);
      this.onTouchMoveHandler = this.onTouchMove.bind(this);
      this.onTouchEndHandler = this.onTouchEnd.bind(this);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      document.addEventListener('touchstart', this.onTouchStartHandler, { passive: true });
      document.addEventListener('touchmove', this.onTouchMoveHandler, { passive: true });
      document.addEventListener('touchend', this.onTouchEndHandler, { passive: true });
      document.addEventListener('touchcancel', this.onTouchEndHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      document.removeEventListener('touchstart', this.onTouchStartHandler);
      document.removeEventListener('touchmove', this.onTouchMoveHandler);
      document.removeEventListener('touchend', this.onTouchEndHandler);
      document.removeEventListener('touchcancel', this.onTouchEndHandler);
    }

    /* A swipe inside a carousel is never perfectly horizontal: the few pixels of
       vertical drift read as a scroll up and pop the header open mid-swipe.
       Track gestures that start inside a horizontal scroller so onScroll can sit
       them out. */
    startsInHorizontalScroller(target) {
      let node = target instanceof Element ? target : null;

      while (node && node !== document.body) {
        if (node.scrollWidth > node.clientWidth + 1) {
          const overflowX = window.getComputedStyle(node).overflowX;
          if (overflowX === 'auto' || overflowX === 'scroll') return true;
        }
        node = node.parentElement;
      }

      return false;
    }

    onTouchStart(event) {
      this.swipeIsHorizontal = false;

      if (event.touches.length !== 1 || !this.startsInHorizontalScroller(event.target)) {
        this.swipeStart = null;
        return;
      }

      this.swipeStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
    }

    onTouchMove(event) {
      if (!this.swipeStart || event.touches.length !== 1) return;

      const deltaX = Math.abs(event.touches[0].clientX - this.swipeStart.x);
      const deltaY = Math.abs(event.touches[0].clientY - this.swipeStart.y);

      if (!this.swipeIsHorizontal && deltaX > 8 && deltaX > deltaY) this.swipeIsHorizontal = true;
      // Covers the momentum scroll that outlives the finger, too.
      if (this.swipeIsHorizontal) this.swipeFreezeUntil = Date.now() + 300;
    }

    onTouchEnd() {
      this.swipeStart = null;
      this.swipeIsHorizontal = false;
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Mid horizontal swipe: leave the header exactly as it is, but keep the
      // reference position current so the next real scroll reads its direction
      // from where the page actually ended up.
      if (Date.now() < this.swipeFreezeUntil && scrollTop > this.headerBounds.top) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["norse-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sticky-header')) {
    class StickyHeader extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.header = document.querySelector('.section-header');
        this.headerIsAlwaysSticky =
          this.getAttribute('data-sticky-type') === 'always' ||
          this.getAttribute('data-sticky-type') === 'reduce-logo-size';
        this.headerBounds = {};

        this.setHeaderHeight();
        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

        if (this.headerIsAlwaysSticky) {
          this.header.classList.add('shopify-section-header-sticky');
        }

        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

        this.swipeStart = null;
        this.swipeIsHorizontal = false;
        this.swipeFreezeUntil = 0;
        this.onTouchStartHandler = this.onTouchStart.bind(this);
        this.onTouchMoveHandler = this.onTouchMove.bind(this);
        this.onTouchEndHandler = this.onTouchEnd.bind(this);

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);
        document.addEventListener('touchstart', this.onTouchStartHandler, { passive: true });
        document.addEventListener('touchmove', this.onTouchMoveHandler, { passive: true });
        document.addEventListener('touchend', this.onTouchEndHandler, { passive: true });
        document.addEventListener('touchcancel', this.onTouchEndHandler, { passive: true });
        this.createObserver();
      }

      setHeaderHeight() {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }

      disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
        document.removeEventListener('touchstart', this.onTouchStartHandler);
        document.removeEventListener('touchmove', this.onTouchMoveHandler);
        document.removeEventListener('touchend', this.onTouchEndHandler);
        document.removeEventListener('touchcancel', this.onTouchEndHandler);
      }

      /* A swipe inside a carousel is never perfectly horizontal: the few pixels
         of vertical drift read as a scroll up and pop the header open mid-swipe.
         Track gestures that start inside a horizontal scroller so onScroll can
         sit them out. */
      startsInHorizontalScroller(target) {
        let node = target instanceof Element ? target : null;
        while (node && node !== document.body) {
          if (node.scrollWidth > node.clientWidth + 1) {
            const overflowX = window.getComputedStyle(node).overflowX;
            if (overflowX === 'auto' || overflowX === 'scroll') return true;
          }
          node = node.parentElement;
        }
        return false;
      }

      onTouchStart(event) {
        this.swipeIsHorizontal = false;
        if (event.touches.length !== 1 || !this.startsInHorizontalScroller(event.target)) {
          this.swipeStart = null;
          return;
        }
        this.swipeStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
      }

      onTouchMove(event) {
        if (!this.swipeStart || event.touches.length !== 1) return;
        const deltaX = Math.abs(event.touches[0].clientX - this.swipeStart.x);
        const deltaY = Math.abs(event.touches[0].clientY - this.swipeStart.y);
        if (!this.swipeIsHorizontal && deltaX > 8 && deltaX > deltaY) this.swipeIsHorizontal = true;
        // Covers the momentum scroll that outlives the finger, too.
        if (this.swipeIsHorizontal) this.swipeFreezeUntil = Date.now() + 300;
      }

      onTouchEnd() {
        this.swipeStart = null;
        this.swipeIsHorizontal = false;
      }

      createObserver() {
        const obs = new IntersectionObserver((entries, o) => {
          this.headerBounds = entries[0].intersectionRect;
          o.disconnect();
        });
        obs.observe(this.header);
      }

      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        // Mid horizontal swipe: leave the header exactly as it is, but keep the
        // reference position current so the next real scroll reads its direction
        // from where the page actually ended up.
        if (Date.now() < this.swipeFreezeUntil && scrollTop > this.headerBounds.top) {
          this.currentScrollTop = scrollTop;
          return;
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);
            this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          this.header.classList.remove('scrolled-past-header');
          requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
      }

      hide() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        document.querySelectorAll('.norse-details[open]').forEach((d) => d.removeAttribute('open'));
      }

      reveal() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
      }

      reset() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      }
    }

    customElements.define('sticky-header', StickyHeader);
  }

  /* ── Smooth accordion animation for mobile menu <details> ─────────────── */
  if (!window.__norseAccordionInit) {
    window.__norseAccordionInit = true;

    const ACC_DURATION = 280;
    const ACC_EASING   = 'cubic-bezier(0.4, 0, 0.2, 1)';

    function getInner(details) {
      // First child after <summary>
      let el = details.firstElementChild;
      while (el && el.tagName.toLowerCase() === 'summary') el = el.nextElementSibling;
      return el;
    }

    function shouldAnimate(details) {
      if (!details.matches('.norse-mm__acc')) return false;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
      return typeof details.animate === 'function';
    }

    function expand(details) {
      const summary = details.querySelector('summary');
      const inner = getInner(details);
      if (!summary || !inner) return;
      details._anim && details._anim.cancel();
      details.open = true;

      const summaryH = summary.getBoundingClientRect().height;
      const innerH = inner.getBoundingClientRect().height;
      const startH = summaryH;
      const endH = summaryH + innerH;

      details.style.overflow = 'hidden';
      const a = details.animate(
        { height: [startH + 'px', endH + 'px'] },
        { duration: ACC_DURATION, easing: ACC_EASING }
      );
      details._anim = a;
      a.onfinish = () => {
        details.style.overflow = '';
        details.style.height = '';
        details._anim = null;
      };
      a.oncancel = () => {
        details.style.overflow = '';
        details.style.height = '';
      };
    }

    function shrink(details) {
      const summary = details.querySelector('summary');
      if (!summary) return;
      details._anim && details._anim.cancel();

      const startH = details.getBoundingClientRect().height;
      const endH = summary.getBoundingClientRect().height;

      details.style.overflow = 'hidden';
      const a = details.animate(
        { height: [startH + 'px', endH + 'px'] },
        { duration: ACC_DURATION, easing: ACC_EASING }
      );
      details._anim = a;
      a.onfinish = () => {
        details.open = false;
        details.style.overflow = '';
        details.style.height = '';
        details._anim = null;
      };
      a.oncancel = () => {
        details.style.overflow = '';
        details.style.height = '';
      };
    }

    document.addEventListener('click', function (e) {
      const summary = e.target.closest('.norse-mm__acc > summary');
      if (!summary) return;
      const details = summary.parentElement;
      e.preventDefault();

      if (details.open) {
        if (shouldAnimate(details)) shrink(details);
        else details.open = false;
      } else {
        // One-at-a-time: close every other open accordion before expanding.
        document.querySelectorAll('.norse-mm__acc[open]').forEach((other) => {
          if (other === details) return;
          if (shouldAnimate(other)) shrink(other);
          else other.open = false;
        });
        if (shouldAnimate(details)) expand(details);
        else details.open = true;
      }
    });
  }

  /* ── Norse Mobile Menu — open/close + body scroll lock ───────────────── */
  if (!customElements.get('norse-mobile-menu')) {
    class NorseMobileMenu extends HTMLElement {
      constructor() {
        super();
        this._onKeydown = this._onKeydown.bind(this);
      }

      connectedCallback() {
        this.querySelectorAll('[data-norse-mm-close]').forEach((el) => {
          el.addEventListener('click', () => this.close());
        });
      }

      open(trigger) {
        if (this.classList.contains('is-open')) return;
        this._trigger = trigger || null;
        this.removeAttribute('hidden');
        // Force a layout pass so the transition runs
        // eslint-disable-next-line no-unused-expressions
        this.offsetHeight;
        requestAnimationFrame(() => this.classList.add('is-open'));
        document.body.classList.add('overflow-hidden');
        document.addEventListener('keydown', this._onKeydown);
        if (this._trigger) this._trigger.setAttribute('aria-expanded', 'true');
        const drawer = this.querySelector('.norse-mm__drawer');
        if (drawer) {
          try { drawer.focus({ preventScroll: true }); } catch (_) { drawer.focus(); }
        }
      }

      close() {
        if (!this.classList.contains('is-open') && !this.hasAttribute('hidden') === false) {
          // already closed
        }
        this.classList.remove('is-open');
        document.body.classList.remove('overflow-hidden');
        document.removeEventListener('keydown', this._onKeydown);
        this.querySelectorAll('.norse-mm__acc[open]').forEach((acc) => {
          acc.open = false;
        });
        if (this._trigger) {
          this._trigger.setAttribute('aria-expanded', 'false');
          try { this._trigger.focus({ preventScroll: true }); } catch (_) { this._trigger.focus(); }
        }
        // Hide after the transition
        setTimeout(() => {
          if (!this.classList.contains('is-open')) this.setAttribute('hidden', '');
        }, 320);
      }

      _onKeydown(e) {
        if (e.key === 'Escape' || e.key === 'Esc') this.close();
      }
    }
    customElements.define('norse-mobile-menu', NorseMobileMenu);
  }

  /* Hook the burger button to open the mobile menu */
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-norse-mm-trigger]');
    if (!trigger) return;
    e.preventDefault();
    const menu = document.getElementById(trigger.getAttribute('aria-controls') || 'NorseMobileMenu')
      || document.querySelector('norse-mobile-menu');
    if (menu && typeof menu.open === 'function') menu.open(trigger);
  });

  /* ── Mega backdrop top: align scrim with #MainContent so it never covers the header ─ */
  (function () {
    const main = document.getElementById('MainContent');
    if (!main) return;

    function syncMegaBackdropTop() {
      document.documentElement.style.setProperty(
        '--norse-mega-backdrop-top',
        `${Math.max(0, Math.round(main.getBoundingClientRect().top))}px`
      );
    }

    function syncIfMegaOpen() {
      if (document.querySelector('.norse-header-wrapper .norse-details:not(.norse-details--more)[open]')) {
        syncMegaBackdropTop();
      }
    }

    window.addEventListener('resize', syncIfMegaOpen);
    window.addEventListener('scroll', syncIfMegaOpen, { passive: true });

    document.addEventListener(
      'toggle',
      function (e) {
        const d = e.target;
        if (!(d instanceof HTMLDetailsElement)) return;
        if (!d.classList.contains('norse-details') || d.classList.contains('norse-details--more')) return;
        if (!d.closest('.norse-header-wrapper')) return;
        if (d.open) syncMegaBackdropTop();
      },
      true
    );

    syncMegaBackdropTop();
  })();

  /* ── Close SHOP / BESTSELLERS mega when the #MainContent backdrop is clicked ─ */
  (function () {
    const main = document.getElementById('MainContent');
    if (!main) return;
    main.addEventListener('click', function (e) {
      if (e.target !== main) return;
      document
        .querySelectorAll('.norse-header-wrapper .norse-details[open]')
        .forEach((d) => {
          if (!d.classList.contains('norse-details--more')) d.removeAttribute('open');
        });
    });
  })();

  /* ── Close mega-menus whenever a drawer (cart, mobile nav) opens ─────── */
  (function () {
    function closeNorseMegaMenus() {
      document.querySelectorAll('.norse-details[open]').forEach((d) => d.removeAttribute('open'));
    }

    function watchDrawer(el) {
      if (!el || el.dataset.norseDrawerWatched === '1') return;
      el.dataset.norseDrawerWatched = '1';
      const obs = new MutationObserver(() => {
        if (el.classList.contains('active')) closeNorseMegaMenus();
      });
      obs.observe(el, { attributes: true, attributeFilter: ['class'] });
    }

    function init() {
      document.querySelectorAll('cart-drawer, mobile-navigation, #mobile-menu-drawer').forEach(watchDrawer);
      const cartIcon = document.getElementById('cart-icon-bubble');
      if (cartIcon && !cartIcon.dataset.norseCartCloseHooked) {
        cartIcon.dataset.norseCartCloseHooked = '1';
        cartIcon.addEventListener('click', closeNorseMegaMenus, true);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  /* ── Bestseller mega-menu — add to cart ──────────────────────────────── */
  (function () {
    const inflight = new WeakSet();

    function closeMegaMenus() {
      document.querySelectorAll('.norse-details[open]').forEach((d) => d.removeAttribute('open'));
      document.querySelectorAll('norse-mobile-menu.is-open').forEach((m) => {
        if (typeof m.close === 'function') m.close();
      });
    }

    function openCart() {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        return;
      }
      const trigger = document.querySelector('#cart-icon-bubble');
      if (trigger && typeof trigger.click === 'function') {
        trigger.click();
      }
    }

    document.addEventListener('submit', function (e) {
      const form = e.target.closest('form[data-norse-bs-form]');
      if (!form) return;
      e.preventDefault();
      if (inflight.has(form)) return;

      const idInput = form.querySelector('input[name="id"]');
      if (!idInput || !idInput.value) return;

      const btn = form.querySelector('button[type="submit"]');
      if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
      inflight.add(form);

      const sections = ['cart-drawer', 'cart-icon-bubble'];
      const cartNotif = document.querySelector('cart-notification');
      if (cartNotif) sections.push('cart-notification');

      const item = { id: Number(idInput.value), quantity: 1 };

      fetch(window.Shopify?.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [item], sections: sections, sections_url: window.location.pathname }),
      })
        .then((res) => res.json().then((body) => { if (!res.ok) throw body; return body; }))
        .then((data) => {
          closeMegaMenus();

          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function') {
            drawer.renderContents(data);
            return;
          }

          const notif = document.querySelector('cart-notification');
          if (notif && typeof notif.renderContents === 'function') {
            notif.renderContents(data);
            return;
          }

          window.location.href = (window.Shopify?.routes?.cart_url) || '/cart';
        })
        .catch((err) => {
          console.error('[Norse BS ATC]', err);
          window.location.href = (window.Shopify?.routes?.cart_url) || '/cart';
        })
        .finally(() => {
          inflight.delete(form);
          if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
        });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
